'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var react = require('@emotion/react');
var index = require('../../../../_virtual/index.cjs');

/**
 * SVG Illustration of add account mobile
 */ const AddAccountMobile = ({ assetColor = index.cjsExports.ASSET_COLORS.grey, size = index.cjsExports.ILLUSTRATION_DIMENSIONS.medium, ...rest })=>{
    const theme = react.useTheme();
    return /*#__PURE__*/ jsxRuntime.jsxs("svg", {
        width: size,
        height: size,
        viewBox: "0 0 104 104",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...rest,
        children: [
            /*#__PURE__*/ jsxRuntime.jsx("ellipse", {
                cx: "51.9362",
                cy: "52",
                rx: "51.9362",
                ry: "52",
                fill: theme.ds5.asset[assetColor]["300"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "42.9922",
                y: "68.625",
                width: "17.576",
                height: "5.22701",
                rx: "1.61599",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M40.485 18.4395H62.9534C64.5856 18.4485 66.1482 19.1028 67.3008 20.2599C68.4534 21.417 69.1027 22.9831 69.1072 24.6172V78.5097C69.1027 80.1468 68.4511 81.7155 67.2948 82.8731C66.1385 84.0307 64.5715 84.683 62.9362 84.6875H40.4679C38.8326 84.683 37.2656 84.0307 36.1093 82.8731C34.953 81.7155 34.3014 80.1468 34.2969 78.5097V66.6561V59.0272V57.1535V24.6172C34.3014 22.9772 34.9554 21.4059 36.1154 20.2478C37.2754 19.0898 38.8468 18.4394 40.485 18.4395Z",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M58.3371 68.7031H45.1123C43.7041 68.7031 42.5625 69.846 42.5625 71.2557C42.5625 72.6655 43.7041 73.8084 45.1123 73.8084H58.3371C59.7453 73.8084 60.8869 72.6655 60.8869 71.2557C60.8869 69.846 59.7453 68.7031 58.3371 68.7031Z",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "48.793",
                y: "73.8105",
                width: "6.04032",
                height: "5.91334",
                rx: "2.95667",
                fill: theme.ds5.asset[assetColor]["300"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "36.9844",
                y: "21.4004",
                width: "29.6647",
                height: "48.9195",
                rx: "1.98179",
                fill: theme.ds5.asset[assetColor]["300"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M59.1836 41.1094C59.5417 41.1096 59.8319 41.3997 59.832 41.7578V44.3271H62.3252C62.6921 44.3274 62.9891 44.6252 62.9893 44.9922C62.9893 45.3593 62.6922 45.657 62.3252 45.6572H59.832V48.2266C59.832 48.5847 59.5417 48.8758 59.1836 48.876C58.8253 48.876 58.5342 48.5849 58.5342 48.2266V45.6572H56.042C55.6747 45.6572 55.377 45.3594 55.377 44.9922C55.3771 44.6251 55.6748 44.3271 56.042 44.3271H58.5342V41.7578C58.5343 41.3996 58.8254 41.1094 59.1836 41.1094Z",
                fill: theme.ds5.asset[assetColor]["600"],
                stroke: "#307553",
                strokeWidth: "0.38691"
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M44.0234 41.1864C44.0234 43.3879 45.8269 45.1716 48.0493 45.1716C50.2718 45.1716 52.0752 43.3879 52.0752 41.1864C52.0752 38.9849 50.2733 37.2012 48.0493 37.2012C45.8253 37.2012 44.0234 38.9849 44.0234 41.1864Z",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M51.5024 46.2305C50.517 46.8977 49.329 47.2886 48.0504 47.2886C46.7718 47.2886 45.5823 46.8977 44.5969 46.2305C42.6537 47.3146 41.3398 49.3805 41.3398 51.7548V52.5824C41.3398 53.4772 42.0689 54.2009 42.9668 54.2009H53.1325C54.0304 54.2009 54.7595 53.4756 54.7595 52.5824V51.7548C54.7595 49.3805 53.4456 47.3146 51.5024 46.2305Z",
                fill: theme.ds5.asset[assetColor]["500"]
            })
        ]
    });
};

exports.AddAccountMobile = AddAccountMobile;
//# sourceMappingURL=AddAccountMobile.cjs.map
